import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import AddrLookup from 'styles/blocks/address/addressLookup';
import { usePrevious } from 'common/customHooks';
import { InfoBox } from 'styles/elements/infoBoxes/info';

/**
 * @return {null}
 */
export function AddressLookup({ addresses, onSelectAddress, isPostcodeOk, clearAddresses, autofillCity, addressesCity }) {
  useEffect(() => {
    if (!isPostcodeOk && !_isEmpty(addresses)) {
      clearAddresses();
    }
  }, [isPostcodeOk, addresses, clearAddresses]);

  const isNewCity = addressesCity !== usePrevious(addressesCity);
  useEffect(() => {
    if (isNewCity && addressesCity) {
      autofillCity(addressesCity);
    }
  }, [addressesCity, autofillCity, isNewCity]);

  if (_isEmpty(addresses)) {
    return null;
  }
  if (!addresses[0].displayName) {
    return <InfoBox>The address search isn&apos;t working. To continue, type in your address below.</InfoBox>;
  }
  return (
    <AddrLookup>
      <AddrLookup.SelectContainer>
        <AddrLookup.Select
          aria-label="Select an address"
          onChange={event => (
            event.target.value === 'Select an address' ? onSelectAddress({ displayName: '', city: '' }) : onSelectAddress(JSON.parse(event.target.value))
          )}
        >
          <AddrLookup.Option>Select an address</AddrLookup.Option>
          {_map(addresses, (address, i) => (
            <AddrLookup.Option key={`address-option-${i}`} value={JSON.stringify(address)}>{address.displayName}</AddrLookup.Option>
          ))}
        </AddrLookup.Select>
      </AddrLookup.SelectContainer>
    </AddrLookup>
  );
}
